// Unpublished Work © 2021-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {Stack, Typography} from '@deere/isg.component-library';

function InfoMessage(props) {
    const {
        title,
        body,
        helper
    } = props;

    return (
        <Stack
            direction='column'
            padding='13.375rem 1.25rem'
            spacing={4}
            textAlign='center'
        >
            <Typography variant='h2'>{title}</Typography>
            <Typography variant='labelLargeSemibold'>{body}</Typography>
            <Typography variant='bodyMedium'>{helper}</Typography>
        </Stack>
    );
}

InfoMessage.propTypes = {
    body: PropTypes.string,
    helper: PropTypes.string,
    title: PropTypes.string
};

export default InfoMessage;
